import { QueryTuple, useLazyQuery } from '@apollo/client';
import { ProjectMilestoneTypeRejectionReasonsInput, ProjectMilestoneTypeRejectionReason } from '@bechtel/types';
import { GET_PROJECT_MILESTONE_TYPE_REASONS } from '@bechtel/client-gql';

export function useProjectMilestoneTypeReasonsQuery(
  fetchFromNetwork?: boolean
): QueryTuple<
  { projectMilestoneTypeRejectionReasons: ProjectMilestoneTypeRejectionReason[] },
  { input: ProjectMilestoneTypeRejectionReasonsInput }
> {
  const response = useLazyQuery<
    { projectMilestoneTypeRejectionReasons: ProjectMilestoneTypeRejectionReason[] },
    { input: ProjectMilestoneTypeRejectionReasonsInput }
  >(
    GET_PROJECT_MILESTONE_TYPE_REASONS,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      : {
          notifyOnNetworkStatusChange: true,
        }
  );
  return response;
}
